module.exports = __webpack_public_path__ + "static/media/deaths-large.9f6fb9f8.png";